<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-row>
      <v-col cols="12" md="6">
        <v-card :loading="loading" class="my-6">
          <template slot="progress">
            <v-progress-linear height="10" indeterminate></v-progress-linear>
          </template>
          <template>
            <v-card-title>{{ card_info.card_no }}</v-card-title>

            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Active Date</td>
                    <td>{{ card_info.active_date }}</td>
                  </tr>
                  <tr>
                    <td>Assign Date</td>
                    <td>{{ card_info.issue_date }}</td>
                  </tr>
                  <tr>
                    <td>CashBack Invoice ID</td>
                    <td>{{ card_info.cashback_invoice_id }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
          <v-divider class="mx-4"></v-divider>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card>
          <template>
            <v-card-title>Card Holder:  {{ patient_info.patient_name }}</v-card-title>
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Patient ID</td>
                    <td>{{ patient_info.patient_id }}</td>
                  </tr>

                  <tr>
                    <td>DOB</td>
                    <td>{{ patient_info.patient_dob }}</td>
                  </tr>
                  <tr>
                    <td>Phone</td>
                    <td>{{ patient_info.patient_phone }}</td>
                  </tr>
                  <tr>
                    <td>Bloog Group</td>
                    <td>{{ patient_info.patient_blood_group }}</td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>{{ patient_info.patient_email }}</td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td>{{ patient_info.patient_address }}</td>
                  </tr>
                  <tr>
                    <td>Registration Date</td>
                    <td>{{ patient_info.admission_date }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
        </v-card>
      </v-col>
    </v-row>
    <v-divider></v-divider>

    <v-card>
      <v-card-title>
        Patient List
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        :search="search"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                @click="viewItem(item)"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                mdi-eye
              </v-icon>
            </template>
            <span>View Patient Details</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-card>
  </div>
</template>
<style scoped></style>
<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      card_no: this.$route.params.id,
      search: "",
      dialog: false,
      loading: true,
      desserts: [],
      headers: [
        { text: "Patient ID", value: "patient_id" },
        { text: "Patient Name", value: "patient_name" },
        { text: "Age", value: "patient_age" },
        { text: "Phone", value: "patient_phone" },
        { text: "Gender", value: "patient_sex" },
        { text: "Blood Group", value: "patient_blood_group" },
        { text: "Reg. Date", value: "admission_date" },

        { text: "Action", value: "actions", sortable: false },
      ],
      patient_info: {},
      errors: "",
      card_info: {
        name: "",
      },
      referral_info: {
        corporate_client: {
          ps_name: "-",
        },
      },
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Patients",
          disabled: false,
          href: "/patients",
        },
        {
          text: "Patient Details",
          disabled: true,
          href: "patient-details",
        },
      ],
    };
  },

  // Fetches posts when the component is created.

  created() {
    this.initialize();
    this.getPatients();
  },
  methods: {
    initialize() {
      atshq
        .get("card/card/" + this.card_no)
        .then((response) => {
          this.loading = false;
          // JSON responses are automatically parsed.

          this.card_info = response.data.data;
          this.patient_info = response.data.data.patient;
          //   this.referral_info = response.data.data.patient;
          //   this.desserts = response.data.data.invoice;
        })
        .catch((e) => {
          // this.errors.push(e);
          console.log(e);
        });
    },
    getPatients() {
      atshq
        .get("card/card-assign-patient/" + this.card_no)
        .then((response) => {
          this.loading = false;
          this.desserts = response.data.data;
        })
        .catch((e) => {
          // this.errors.push(e);
          console.log(e);
        });
    },
    editItem(item) {
      window.location.href = "/patient-create/" + item.patient_id;
    },
    viewItem(item) {
      window.location.href = "/patient-details/" + item.patient_id;
    },
    visionTherapy(item) {
      window.location.href = "/services/vision-therapy/" + item.patient_id;
    },
  },
};
</script>